'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import { ADOPTION_COUNT, clsx, euclidCircularBRegular, proximaNovaABlack, usePageLayout } from '@libs/common-next';
import type { LivesSavedProps } from './types';
import './LivesSaved.scss';
export const trackingData = (data: object) => Object.assign(data, {
  ...layoutEvents.headerClick
});
export default function LivesSaved(t0) {
  const $ = _c(30);
  const {
    className,
    variant,
    link,
    text,
    display: t1
  } = t0;
  const display = t1 === undefined ? true : t1;
  const {
    adoptionCount
  } = usePageLayout();
  let t2;
  if ($[0] !== className || $[1] !== variant) {
    t2 = clsx(className, variant === "footer" && ["lives-saved__text", "lives-saved__text--strong"], variant === "header" && ["lives-saved__text", "lives-saved__text--normal"]);
    $[0] = className;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const classes = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx(euclidCircularBRegular.className, "link-wrapper");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const linkWrapperClasses = t3;
  const shouldDisplay = display && adoptionCount;
  if (!shouldDisplay) {
    return null;
  }
  let t4;
  if ($[4] !== adoptionCount) {
    t4 = adoptionCount?.toLocaleString();
    $[4] = adoptionCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const livesSavedValue = t4;
  const livesSavedText = text || ADOPTION_COUNT.TEXT;
  switch (variant) {
    case "footer":
      {
        const t5 = link?.webUrl || ADOPTION_COUNT.LINK;
        let t6;
        if ($[6] !== livesSavedValue) {
          t6 = <strong className={proximaNovaABlack.className}>{livesSavedValue}</strong>;
          $[6] = livesSavedValue;
          $[7] = t6;
        } else {
          t6 = $[7];
        }
        let t7;
        if ($[8] !== livesSavedText || $[9] !== t6) {
          t7 = <span>{t6} {livesSavedText}</span>;
          $[8] = livesSavedText;
          $[9] = t6;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        let t8;
        if ($[11] !== classes || $[12] !== t5 || $[13] !== t7) {
          t8 = <div data-testid="lives-saved-footer" className="lives-saved--footer"><Link className={classes} href={t5} prefetch={false}>{t7}</Link></div>;
          $[11] = classes;
          $[12] = t5;
          $[13] = t7;
          $[14] = t8;
        } else {
          t8 = $[14];
        }
        return t8;
      }
    case "header":
      {
        const t5 = link?.webUrl || ADOPTION_COUNT.LINK;
        let t6;
        if ($[15] !== link?.webUrl || $[16] !== livesSavedText || $[17] !== livesSavedValue) {
          t6 = () => dataLayerPush(trackingData({
            selection: `${livesSavedValue} ${livesSavedText}`,
            link_url: getBaseUrlJoined(link?.webUrl || ADOPTION_COUNT.LINK)
          }));
          $[15] = link?.webUrl;
          $[16] = livesSavedText;
          $[17] = livesSavedValue;
          $[18] = t6;
        } else {
          t6 = $[18];
        }
        let t7;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <Icon name="charities-fill" size="sm" className="sparky-u-margin-right-xs" />;
          $[19] = t7;
        } else {
          t7 = $[19];
        }
        let t8;
        if ($[20] !== livesSavedValue) {
          t8 = <span>{livesSavedValue}</span>;
          $[20] = livesSavedValue;
          $[21] = t8;
        } else {
          t8 = $[21];
        }
        let t9;
        if ($[22] !== livesSavedText || $[23] !== t8) {
          t9 = <span className={linkWrapperClasses}>{t7}{t8} {livesSavedText}</span>;
          $[22] = livesSavedText;
          $[23] = t8;
          $[24] = t9;
        } else {
          t9 = $[24];
        }
        let t10;
        if ($[25] !== classes || $[26] !== t5 || $[27] !== t6 || $[28] !== t9) {
          t10 = <div data-testid="lives-saved-header" className="lives-saved"><Link className={classes} href={t5} onClick={t6} prefetch={false}>{t9}</Link></div>;
          $[25] = classes;
          $[26] = t5;
          $[27] = t6;
          $[28] = t9;
          $[29] = t10;
        } else {
          t10 = $[29];
        }
        return t10;
      }
    default:
      {
        return null;
      }
  }
}